const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-uiutils",
    meta: {},
    name: "m-uiutils",
    component: () => import("@/modules/muiutils/RootView")
});

export default Routes;